import { jsx as _jsx } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { Container } from "./Container";
import { colors } from "./theme";
export function RTCText({ alignment = "left", textColor = colors.black, linkColor = colors.blueMain, content = "", size = "medium", typography = "inherit", }) {
    return (_jsx(ContainerStyled, { children: _jsx(Content, { alignment: alignment, typography: typography, textColor: textColor, fontSize: fontSize[size], linkColor: linkColor, dangerouslySetInnerHTML: { __html: content } }, void 0) }, void 0));
}
const ContainerStyled = styled(Container)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});
const Content = styled.div(({ alignment, typography, textColor, fontSize, linkColor }) => ({
    "& > p": {
        textAlign: alignment,
        fontFamily: typography,
        color: textColor,
        fontSize: fontSize,
        wordBreak: "break-word",
        "&:first-of-type": {
            marginTop: 0,
        },
        "&:last-of-type": {
            marginBottom: 0,
        },
        "& a": {
            color: linkColor,
        },
    },
}));
const fontSize = {
    "very-big": "1.8rem",
    big: "1.6rem",
    medium: "1.4rem",
    small: "1.2rem",
};
//# sourceMappingURL=Text.js.map